module.exports = "/_next/static/images/Frame@2x-ce1980312b28f0cf6c7a3f5c40652d46.webp";